import React, { useContext, useState } from "react";
import { modalBoxStyle } from "./styles";
import {
  Button,
  Typography,
  Box,
  Modal,
  CircularProgress,
} from "@mui/material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import Store from "../../Store/Store";
import { useMutation, useQueryClient } from "react-query";
import inventoryClient from "../../clients/inventoryClient";

const DeleteInvoiceModal = ({
  invoiceId,
  isOpen,
  toggleModalOpen
}) => {
  const [loading, toggleLoading] = useState(false);
  const store = useContext(Store);
  const queryClient = useQueryClient();

  const closeModal = () => {
    toggleModalOpen();
  };

  const deleteInvoiceMutation = useMutation(
    inventoryClient.deleteInvoice,
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [
            "invoices",
            {
              establishmentId: store?.currentEstablishment.id,
            },
          ],
        });
        queryClient.refetchQueries({
          queryKey: [
            "invoices",
            {
              establishmentId: store?.currentEstablishment.id,
            },
          ],
        });
        closeModal();
      },
    }
  );

  const handleDeleteCallback = async () => {
    try {
      toggleLoading(true);
      const archivePayload = {
        establishmentId: store.currentEstablishment?.id,
        invoiceId: invoiceId,
      };
  
      deleteInvoiceMutation.mutate(archivePayload);
      toggleLoading(false);
    } catch (err) {
      console.log(err);
      toggleLoading(false);
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={closeModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={modalBoxStyle}>
        {loading ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress />
          </div>
        ) : (
          <>
            <Box>
              <Box
                sx={{
                  marginBottom: "1rem",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <DeleteOutlineOutlinedIcon sx={{ fontSize: "60px" }} />
              </Box>
              <Box
                sx={{
                  marginBottom: "1rem",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Typography variant="h2">Delete Invoice</Typography>
              </Box>
              <Box
                sx={{
                  marginBottom: "1rem",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Typography variant="body1" sx={{ textAlign: "center" }}>
                  {"Are you sure you want to delete this invoice? "}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ textAlign: "center", marginTop: 1 }}
                >
                  {
                    "By selecting yes, you will lose all information associated with this invoice."
                  }
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Button
                  sx={{ borderRadius: 2 }}
                  variant="outlined"
                  onClick={() => {
                    toggleModalOpen();
                  }}
                >
                  <Typography variant="smallButton">No, Cancel</Typography>
                </Button>
                <Button
                  variant="contained"
                  type="submit"
                  sx={{ borderRadius: 2, marginLeft: 2 }}
                  onClick={handleDeleteCallback}
                >
                  <Typography variant="smallButton">Yes, Delete</Typography>
                </Button>
              </Box>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default DeleteInvoiceModal;